/* Snowreel theme scripts: countdowns, sticky buy bar, per-orb style selects.
   Vanilla JS, no libraries. All customer-facing text comes from section settings
   via data attributes. Safe on pages that have none of these sections. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseTarget(date, offset) {
    date = (date || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
    if (!/^[+-]\d{2}:\d{2}$/.test(offset || '')) offset = '-05:00';
    var t = new Date(date + 'T23:59:59' + offset);
    return isNaN(t.getTime()) ? null : t;
  }

  /* ------------------------------------------------------------ countdowns */
  function initDeadline(el) {
    if (el.__srDeadline) return;
    var target = parseTarget(el.getAttribute('data-date'), el.getAttribute('data-offset'));
    var before = el.querySelector('[data-sr-before]');
    var after = el.querySelector('[data-sr-after]');
    var clock = el.querySelector('[data-sr-clock]');
    var live = el.querySelector('[data-sr-live]');
    var dEl = el.querySelector('[data-sr-days]');
    var hEl = el.querySelector('[data-sr-hours]');
    var mEl = el.querySelector('[data-sr-minutes]');
    var labels = {
      days: el.getAttribute('data-label-days') || '',
      hours: el.getAttribute('data-label-hours') || '',
      minutes: el.getAttribute('data-label-minutes') || '',
    };
    var timer = null;
    var lastMinute = null;

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      if (!target) {
        if (clock) clock.hidden = true;
        stop();
        return;
      }
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (before) before.hidden = true;
        if (after) after.hidden = false;
        stop();
        return;
      }
      if (before) before.hidden = false;
      if (after) after.hidden = true;
      var totalMinutes = Math.floor(diff / 60000);
      var days = Math.floor(totalMinutes / 1440);
      var hours = Math.floor((totalMinutes % 1440) / 60);
      var minutes = totalMinutes % 60;
      if (dEl) dEl.textContent = String(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(minutes);
      if (clock) clock.classList.add('is-ready');
      if (live && totalMinutes !== lastMinute) {
        lastMinute = totalMinutes;
        live.textContent =
          days + ' ' + labels.days + ', ' + hours + ' ' + labels.hours + ', ' + minutes + ' ' + labels.minutes;
      }
    }

    function start() {
      stop();
      tick();
      if (target && target.getTime() > Date.now()) timer = setInterval(tick, 20000);
    }

    function onVisibility() {
      if (document.hidden) stop();
      else start();
    }

    document.addEventListener('visibilitychange', onVisibility);
    start();

    el.__srDeadline = {
      destroy: function () {
        stop();
        document.removeEventListener('visibilitychange', onVisibility);
        el.__srDeadline = null;
      },
    };
  }

  function initDeadlines(root) {
    root.querySelectorAll('[data-sr-deadline]').forEach(initDeadline);
    root.querySelectorAll('[data-sr-cutoff]').forEach(function (el) {
      var t = parseTarget(el.getAttribute('data-date'), el.getAttribute('data-offset'));
      if (t && Date.now() > t.getTime()) el.hidden = true;
    });
  }

  /* ------------------------------------------------------------ sticky buy bar */
  function findMainProductInfo() {
    return document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
  }

  function initStickyBar(bar) {
    if (bar.__srSticky) return;
    var productInfo = findMainProductInfo();
    if (!productInfo) return;

    var btn = bar.querySelector('[data-sr-sticky-button]');
    var priceEl = bar.querySelector('[data-sr-sticky-price]');
    var variantEl = bar.querySelector('[data-sr-sticky-variant]');
    var label = bar.getAttribute('data-label') || '';
    var soldOutLabel = bar.getAttribute('data-sold-out') || label;
    var desktop = !bar.classList.contains('sr-sticky--mobile-only');
    var visible = false;
    var frame = null;
    var buyArea = null;
    var io = null;
    var mo = null;
    var unsubscribe = null;

    function mainButton() {
      return productInfo.querySelector('product-form [type="submit"]');
    }

    function setVisible(on) {
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      var html = document.documentElement;
      html.classList.toggle('sr-sticky-on', on);
      html.classList.toggle('sr-sticky-desktop', on && desktop);
      if (on) html.style.setProperty('--sr-sticky-height', bar.offsetHeight + 'px');
    }

    function sync() {
      frame = null;
      var main = mainButton();
      if (btn && main) {
        var disabled = main.hasAttribute('disabled');
        var text = (main.textContent || '').trim();
        var strings = window.variantStrings || {};
        var soldOut = disabled && (text === strings.soldOut || text === strings.unavailable);
        btn.disabled = disabled;
        btn.textContent = soldOut ? soldOutLabel : label;
      }
      var sectionId = productInfo.getAttribute('data-section');
      var priceRoot = sectionId ? productInfo.querySelector('#price-' + sectionId) : null;
      if (priceEl && priceRoot) {
        var price = priceRoot.querySelector('.price');
        var item = null;
        if (price) {
          item = price.classList.contains('price--on-sale')
            ? price.querySelector('.price__sale .price-item--last')
            : price.querySelector('.price__regular .price-item--regular');
        }
        if (item && item.textContent.trim()) priceEl.textContent = item.textContent.trim();
      }
      if (variantEl) {
        var data = productInfo.querySelector('variant-selects [data-selected-variant]');
        if (data) {
          try {
            var v = JSON.parse(data.textContent);
            if (v && v.title) variantEl.textContent = v.title;
          } catch (e) {
            /* keep the server-rendered title */
          }
        }
      }
    }

    function queueSync() {
      if (!frame) frame = requestAnimationFrame(sync);
    }

    function observeBuyArea() {
      // observe a block-level box: <product-form> can be display:inline
      var area = productInfo.querySelector('.product-form__buttons') || mainButton();
      if (!area || area === buyArea) return;
      if (io && buyArea) io.unobserve(buyArea);
      buyArea = area;
      if (io) io.observe(buyArea);
    }

    if ('IntersectionObserver' in window) {
      // The root is extended far below the viewport, so the buy buttons only stop "intersecting"
      // once they are above the top edge. That also catches jumps (anchor links) that skip past them.
      io = new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (scrolledPast !== visible) setVisible(scrolledPast);
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
    }
    observeBuyArea();

    mo = new MutationObserver(function () {
      if (buyArea && !buyArea.isConnected) {
        buyArea = null;
        observeBuyArea();
      }
      queueSync();
    });
    mo.observe(productInfo, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, queueSync);
    }

    function onClick() {
      var main = mainButton();
      if (!main || main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true') return;
      main.click();
    }
    if (btn) btn.addEventListener('click', onClick);

    sync();

    bar.__srSticky = {
      destroy: function () {
        if (io) io.disconnect();
        if (mo) mo.disconnect();
        if (typeof unsubscribe === 'function') unsubscribe();
        if (btn) btn.removeEventListener('click', onClick);
        if (frame) cancelAnimationFrame(frame);
        setVisible(false);
        bar.__srSticky = null;
      },
    };
  }

  function initSticky(root) {
    root.querySelectorAll('[data-sr-sticky]').forEach(initStickyBar);
  }

  function destroySticky(root) {
    root.querySelectorAll('[data-sr-sticky]').forEach(function (bar) {
      if (bar.__srSticky) bar.__srSticky.destroy();
    });
  }

  /* ------------------------------------------------------------ per-orb styles */
  function syncBundle(wrapper) {
    var fields = wrapper.querySelectorAll('[data-sr-orb-index]');
    if (!fields.length) return;
    var checked = wrapper.querySelector('[data-sr-bundle-option] input[type="radio"]:checked');
    var count = 1;
    if (checked) {
      var parsed = parseInt(String(checked.value).trim(), 10);
      if (parsed > 0) count = parsed;
    }
    fields.forEach(function (field) {
      var on = parseInt(field.getAttribute('data-sr-orb-index'), 10) <= count;
      field.hidden = !on;
      var select = field.querySelector('select');
      if (select) select.disabled = !on;
    });
  }

  function initBundleStyles(root) {
    root.querySelectorAll('[data-sr-bundle]').forEach(syncBundle);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.matches('[data-sr-bundle-option] input[type="radio"]')) return;
    var wrapper = target.closest('[data-sr-bundle]');
    if (wrapper) syncBundle(wrapper);
  });

  /* ------------------------------------------------------------ hero video */
  function initVideos(root) {
    if (!reduceMotion.matches) return;
    root.querySelectorAll('[data-sr-video] video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
      video.controls = true;
    });
  }

  /* ------------------------------------------------------------ lifecycle */
  function init(root) {
    root = root || document;
    initDeadlines(root);
    initSticky(root);
    initBundleStyles(root);
    initVideos(root);
  }

  function destroy(root) {
    root.querySelectorAll('[data-sr-deadline]').forEach(function (el) {
      if (el.__srDeadline) el.__srDeadline.destroy();
    });
    destroySticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      initBundleStyles(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    init(section);
    // The main product was re-rendered: rebind sticky bars to the new product-info.
    if (section.querySelector && section.querySelector('product-info')) {
      destroySticky(document);
      initSticky(document);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var bar = event.target.querySelector && event.target.querySelector('[data-sr-sticky]');
    if (bar) bar.classList.add('is-selected');
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var bar = event.target.querySelector && event.target.querySelector('[data-sr-sticky]');
    if (bar) bar.classList.remove('is-selected');
  });
})();
